'use client';

import {
  ControllerRenderProps,
  FieldValues,
  UseFormReturn,
} from 'react-hook-form';

import { InputProps } from '@nextui-org/react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Rate } from '@/components/ui/rate';
import React from 'react';

interface Props extends InputProps {
  formReactHookForm: UseFormReturn<any>;
  name: string;
}
export const FormRate = ({ formReactHookForm, ...props }: Props) => {
  return (
    <FormField
      control={formReactHookForm.control}
      name={props.name}
      render={({ field }) => <FormItemRate {...props} {...field} />}
    />
  );
};

const FormItemRate = (
  props: Omit<Props, 'formReactHookForm'> &
    ControllerRenderProps<FieldValues, string>,
) => {
  return (
    <FormItem>
      <FormLabel className="z-10 pointer-events-none origin-top-left rtl:origin-top-right subpixel-antialiased block text-foreground-500 cursor-text after:content-['*'] after:text-danger after:ml-0.5 rtl:after:ml-[unset] rtl:after:mr-0.5 relative will-change-auto !duration-200 !ease-out motion-reduce:transition-none transition-[transform,color,left,opacity] group-data-[filled-within=true]:text-default-600 group-data-[filled-within=true]:pointer-events-auto group-data-[filled-within=true]:scale-85 text-small pb-0.5 pe-2 max-w-full text-ellipsis overflow-hidden">
        {' '}
        {props.label}
      </FormLabel>
      <FormControl>
        <Rate
          className=" w-[165px]"
          value={Number(props.value) || 0}
          onChange={props.onChange}
          size={40}
        />
      </FormControl>
      <FormMessage
        style={{
          color: '#f31260',
        }}
      />
    </FormItem>
  );
};
